import changeCase from 'change-case'
import { func, number, node, object } from 'prop-types'
import { kuiperClassNames } from '../../utils'
import ColumnSizer from '../ColumnSizer'
import SortControl from '../SortControl'
import './styles.scss'

const HeaderCell = ({
  column,
  customHeader,
  index,
  onChangeWidths,
  onSortClick,
  sortParams,
  style,
}) => {
  if (!column.visible) return null
  return (
    <th
      scope="col"
      style={style}
      className={kuiperClassNames(
        'header-cell',
        `${changeCase.kebab(column.type)}`
      )}
    >
      <div className={kuiperClassNames('title-wrapper')}>
        {customHeader || column.title}
      </div>
      {column.isSortable && (
        <SortControl
          displayTitle={column.title}
          onSortClick={onSortClick}
          sortParams={sortParams}
          sortKey={column.sortKey}
        />
      )}
      {column.isResizeable && (
        <ColumnSizer onChangeWidth={onChangeWidths} index={index} />
      )}
    </th>
  )
}

HeaderCell.propTypes = {
  column: object.isRequired,
  customHeader: node,
  index: number.isRequired,
  onChangeWidths: func,
  onSortClick: func,
  sortParams: object,
  style: object,
}

export default HeaderCell
